import { IGameState } from 'State/Game/IGameState';
import { ProgressStateHelper } from 'State/Player/Progress/ProgressStateHelper';
import CardStateHelper from '../CardStateHelper';
import BaseModifierBehavior from './BaseModifierBehavior';

export default class LevelAttemptsModifierBehavior extends BaseModifierBehavior {
    public onLevelLoaded(state: IGameState): IGameState {
        return this.removeCardIfOverMaxAttempts(state);
    }

    public update(state: IGameState): IGameState {
        return this.removeCardIfOverMaxAttempts(state);
    }

    private removeCardIfOverMaxAttempts(state: IGameState): IGameState {
        const currentAttempts = ProgressStateHelper.getLevelData(state, state.levelState.levelNumber).attempts;
        if (currentAttempts > this.modifier.properties.maxAttempts) {
            let cardsState = CardStateHelper.removeCard(state.levelState.cardsState, this.cardID);
            cardsState = CardStateHelper.checkCardsObscured(cardsState);
            state = CardStateHelper.updateGameState(state, cardsState);
        }
        return state;
    }
}
